export function collectLineProjects(items = []) {
  const map = new Map();
  for (const item of items) {
    const project = item?.project;
    if (!project?.id) continue;
    map.set(String(project.id), project);
  }
  return Array.from(map.values()).sort((a, b) =>
    String(a.name || '').localeCompare(String(b.name || ''), 'es'),
  );
}

export function formatLineProjectsLabel(items = []) {
  const projects = collectLineProjects(items);
  if (projects.length === 0) return '—';
  if (projects.length === 1) {
    const project = projects[0];
    return project.code ? `${project.code} - ${project.name}` : project.name;
  }
  return `${projects.length} proyectos`;
}
